import { Card, Col, Flex, Row, Statistic, Typography } from "antd";
import {
  DollarCircleOutlined,
  FallOutlined,
  PayCircleOutlined,
  RiseOutlined,
} from "@ant-design/icons";
import CountUp from "react-countup";

const { Text, Title } = Typography;

const Rise = () => (
  <RiseOutlined style={{ color: "var(--ant-color-error)", marginRight: 6 }} />
);

const Drop = () => (
  <FallOutlined style={{ color: "var(--ant-color-success)", marginRight: 6 }} />
);

function BillingHighlightCard({ currentValue = 0, lastValue = 0 }) {
  const numberFormat = {
    locales: "en-MY",
    options: { style: "currency", currency: "MYR" },
  };

  return (
    <Card
      size="small"
      bordered
      styles={{
        body: {
          position: "relative",
        },
      }}
    >
      {/* <DollarCircleOutlined
        style={{
          position: "absolute",
          right: 24,
          top: 18,
          fontSize: 48,
          color: "var(--ant-green)",
        }}
      /> */}
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Flex justify="start" align="end" gap={8}>
            <Statistic
              title={
                <Title level={5} style={{ margin: 0, marginBottom: 8 }}>
                  Estimated Billing
                </Title>
              }
              valueStyle={{
                fontSize: "var(--ant-font-size-heading-2)",
                fontWeight: "var(--ant-font-weight-strong)",
              }}
              value={currentValue}
              precision={2}
              formatter={(value) => (
                <CountUp
                  end={value}
                  separator=","
                  duration={1.5}
                  decimals={2}
                />
              )}
              prefix={
                <Title level={2} style={{ margin: 0 }}>
                  RM
                </Title>
              }
            ></Statistic>
          </Flex>
          <Flex justify="start" align="center" gap={4}>
            {currentValue > lastValue ? <Rise /> : <Drop />}
            <Text>RM {lastValue?.toLocaleString(numberFormat)}</Text>
            <Text type="secondary">Last Month (To-Date)</Text>
          </Flex>
        </Col>
      </Row>
    </Card>
    // <Card
    //   title={
    //     <Title level={5} style={{ margin: 0 }}>
    //       <DollarCircleOutlined style={{ marginRight: 12 }} />
    //       Estimated Billing
    //     </Title>
    //   }
    //   size="small"
    //   bordered
    // >
    //   <Row gutter={[12, 12]}>
    //     <Col span={24}>
    //       <Flex justify="start" align="end" gap={8}>
    //         <Title
    //           level={2}
    //           style={{ margin: 0 }}
    //           ellipsis={{
    //             tooltip: (
    //               <>
    //                 {currentValue.toLocaleString("en-MY", {
    //                   style: "currency",
    //                   currency: "MYR",
    //                 })}
    //               </>
    //             ),
    //           }}
    //         >
    //           {currentValue.toLocaleString("en-MY", {
    //             style: "currency",
    //             currency: "MYR",
    //           })}
    //         </Title>
    //       </Flex>
    //     </Col>
    //     {/* <Col span={24}>
    //                 <Flex justify='end' align='center' gap={8}>
    //                     <Title level={4} style={{ margin: 0 }} type={ currentValue > lastValue ? 'success' : 'danger'}> {lastValue > currentValue ? <FallOutlined /> : <RiseOutlined />}
    //                     </Title>
    //                     <Text italic>Last : {lastValue.toLocaleString('en-MY',{style: "currency", currency: "MYR"})} ( { ((currentValue - lastValue) / lastValue).toLocaleString('en-US', { maximumFractionDigits: 1, style: 'percent' }) } )
    //                     </Text>
    //                 </Flex>
    //             </Col> */}
    //   </Row>
    // </Card>
  );
}

export default BillingHighlightCard;
